function Loading() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
            <div className="text-center">
                {/* Spinner */}
                <div className="inline-block w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>

                {/* Text */}
                <p className="text-gray-400 text-lg">
                    Проверка доступа...
                </p>
            </div>
        </div>
    );
}

export default Loading;
